import React, { Fragment, useState } from "react";
import { Tooltip } from 'antd';
import styles from "./scss/filelists.module.scss";
import iconpdf from "../../../styles/images/filepdf.svg";
import iconppt from "../../../styles/images/fileppt.svg";
import iconword from "../../../styles/images/fileword.svg";
import iconxls from "../../../styles/images/fileexcel.svg";
import iconzip from "../../../styles/images/filezip.svg";
import iconotherformat from "../../../styles/images/otherformat.svg";
import iconmusic from "../../../styles/images/grid_music.svg";
import viewarrow from "../../../styles/images/viewarrow.svg";
import iconnotsupport from "../../../styles/images/hiddenimage.svg";
import ChatAttachmentsOption from "../chatWidgets/chatAttachmentOption";
import { URInput } from "../../../shared/widgets/input";
import { excelFormats, getFileSize, imageFormat,
  mp3Formats,
  pdfFormats, pptFormats, wordFormats, zipFormats, videoFormat } from "../../../base/utils";
import _ from "lodash";
import FilePreview from "../chatWidgets/filePreview";
import AllFilePreview from "../chatWidgets/allFilePreview";
import { initialStateModel, rightSidePanelDetails } from "../../../models/model";
import { useSelector } from "react-redux";
import { URFileSkeleton } from "../../../shared/skeletonLoading/filesSkeleton";
import NoContent from "../../../shared/widgets/noContent";
import FileNoFound from "../../../styles/images/empty_states/files_empty_state.svg";
import moment from "moment";
import { HighlightInner } from "../../contacts/rightsidebar/highlight";
type filesrightprops={
  fileList:any;
}
type fileMessageState = {
  isOpen:boolean;
  //id:any;
  isallFiles:boolean;
  allfiledata:any;
  allFilesList:any;
  imagefiledata:any;
  imagefileList:any;
  searchWord:string;
}
export default function FilesListsRight({ fileList }: filesrightprops) {
  const contact: rightSidePanelDetails = useSelector((state: initialStateModel) =>
    state.chatRightSidePanelReducer);
  let {fileListDetails,isfile}=contact;
  //const {chatWindowDetails}: chatwindowDetails = useSelector((state: initialStateModel) => state.chatWindowReducer);
  
  const [fileState, setfileState] = useState<fileMessageState>({
    isOpen: false,
    isallFiles: false,
    imagefileList: fileList,
    allfiledata: {},
    allFilesList: fileList,
    imagefiledata: fileList,
    searchWord:""
  });


  const openOtherFiles=(file:any)=>{
    if(file?.message?.body?.isCloudfiles) {
      window.open(file?.message?.body?.filePath)
    }
    else {
      if(file?.message?.messageType === "IMAGE" || videoFormat.indexOf(file?.message?.body?.fileType) !== -1 ){
        onclickgetId(file)
      } else if(videoFormat.indexOf(file?.message?.body?.fileType) === -1 && mp3Formats.indexOf(file?.message?.body?.fileType) === -1 ) {
        onclickallfilegetId(file);
      } else if( zipFormats.indexOf(file?.message?.body?.fileType) !== -1) {
        return;
      }
    }
  }
  const onclickgetId=(file:any)=>{
    setfileState({...fileState,imagefiledata:file,isOpen:!fileState.isOpen});  
  };

  const onclickallfilegetId=(file:any)=>{
    setfileState({...fileState,allfiledata:file,isallFiles:!fileState.isallFiles
    });};

  
  const FilePreviewer = ()=>{
    setfileState({...fileState,isOpen:!fileState.isOpen});
  };

  const allFilePreviewer=()=>{
    setfileState({...fileState,isallFiles:!fileState.isallFiles});
  };

  const searchFile=_.debounce((e:any)=>{
    let searchText=e.target.value.toLowerCase();
    let response:any =   _.filter(fileState.allFilesList, function(data:any) {
    let messageBody = data?.message?.body;
    let fileName =messageBody?.fileName || ""; 
      
      return (((fileName).toLowerCase()).includes(searchText))

    });
     
    setfileState({...fileState,imagefileList:response,searchWord:searchText});
  },1000);  
  
  // let imagefiledata = _.filter(fileState.imagefileList, ((datas: any) => {
  //   let messageBody = datas?.message?.body;
  //   return imageFormat.indexOf(messageBody?.fileType) > -1 ||
  //   pdfFormats.indexOf(messageBody?.fileType) > -1 ||
  //   wordFormats.indexOf(messageBody?.fileType) > -1 ||
  //   pptFormats.indexOf(messageBody?.fileType) > -1 ||
  //   excelFormats.indexOf(messageBody?.fileType) > -1 ||
  //   mp3Formats.indexOf(messageBody?.fileType) > -1 ||
  //     videoFormat.indexOf(messageBody?.fileType) > -1 ||
  //     zipFormats.indexOf(messageBody?.fileType) > -1
  //   }));
 //  console.log("Files List ---->",imagefiledata,fileState.imagefileList);

  return (
    <>

      <div className={`fadeIn ${styles.taskmain}`}>
        <div className={styles.rightbartop}>
        <span className={styles.titleText}>Files</span>
          <div className={styles.searchFull}>
            <div className={styles.lefts}>
              <URInput placeHolder="Search" className="rightbarsearch"  onChange={searchFile}/>
            </div>
       
          </div>
        </div>
        {(isfile===false && fileListDetails.length === 0) ?
          [1,2,3,4,5,6].map((data:any)=>(
            <div className={styles.skeletonSec} key={data}>
              <URFileSkeleton key={data}/>
            </div>
          )):
          (fileState?.imagefileList?.length === 0 && 
         isfile === true)  ? <NoContent image={FileNoFound}
              title={"Worktual files"}
              description={<>No files.</>} />:
        <div className={`${styles.rightbarbottom} ${styles.marbtmmin}`}>
          {fileState.imagefileList?.map((file: any, i: number)=>
            {
             let messageBody = file?.message?.body;
             let filePath = messageBody?.filePath;
             let fileType =messageBody?.fileType;
            let fileSize =messageBody?.filesize;
            // let fileName =messageBody?.fileName;
            let fileName =messageBody?.fileName.length > 40 ? messageBody?.fileName.substring(0, 39) + "..." : messageBody?.fileName;
            let isCloudFiles  =messageBody?.isCloudfiles || false;
            let timestamp =   moment(file?.timestamp).format("ddd, MMM Do YYYY");
          
            return (
              <Fragment key={i} >
              
              <div key={i} className={styles.chatAttachmentList}>
               
                <div className={styles.filesChat} onClick={()=>openOtherFiles(file)}>
                  <div className={styles.filesImage}>
                    { imageFormat.indexOf(fileType)  !== -1 && !isCloudFiles?
                         <img src={filePath} alt={fileName}/> 
                         :
                         fileType.includes('image') && isCloudFiles?
                         <img src={iconnotsupport} alt={fileName}
                         />:
                        mp3Formats.indexOf(fileType) !== -1 ?
                        <img src={iconmusic} alt={fileName} />:
                        videoFormat.indexOf(fileType) !== -1 ? 
                            <div className="videoFiles">
                            <video className="videoFluid" controls={true} preload="metadata">
                              <source src={file?.filePath} type="video/mp4" />
                            </video>
                            <div className="videoPlay"></div>
                          </div> :
                      excelFormats.indexOf(fileType) !== -1  ?
                        <img src={iconxls} alt={fileName}
                       />:
                        pptFormats.indexOf(fileType) !== -1  ?
                          <img src={iconppt} alt={fileName}
                          />:
                          wordFormats.indexOf(fileType)  !== -1 ?
                            <img src={iconword} alt={fileName}
                            />:
                            zipFormats.indexOf(fileType)  !== -1  ?
                              <img src={iconzip} alt={fileName}/>:
                              pdfFormats.indexOf(fileType) !== -1 ?
                               <img src={iconpdf} alt={fileName}/> :
                               <img src={iconnotsupport} alt={fileName}/>
                    }
                  </div>
                  <div className={styles.filesDetails}>
                    <Tooltip mouseEnterDelay={0.5}  placement="top" title={fileName} overlayClassName="tooltipCenter">
                        <span className={styles.fileName} > 
                          <HighlightInner content={fileName}
                          searchedData={fileState.searchWord}></HighlightInner>
                        {/* {
                        fileName && fileName.length > 20 ?
                          fileName.substring(0, 20) + "..." : fileName} */}
                      </span>
                    </Tooltip>
                    <span className={styles.fileDt}>{getFileSize(fileSize)}</span>
                    <span className={styles.fileDate}> {timestamp}</span>
                   { isCloudFiles && <span className={styles.fileDt}>{  filePath.includes('https://app.box.com') ? ' Box'  : " Drive" }</span>}
                  </div>
                  {isCloudFiles&& <div className={styles.forarrowview}>
                      <img src={viewarrow} alt=""/>
                   </div>}
                  {/* <div className={styles.attachmentHover} ><ChatAttachmentsOption
                    data={file} overAllFileData ={fileState.allFilesList} previewopen={onclickgetId} fromFiles={true}/></div> */}
                </div>
               
              </div>
              </Fragment>
            )})}
            {fileState.isallFiles &&
            <AllFilePreview isOpen={fileState.isallFiles}
            data={fileState.allfiledata}
            groupdata={fileState.allFilesList}
            previewopen={allFilePreviewer} />}
            {fileState.isOpen &&
            <FilePreview isOpen={fileState.isOpen}
            data={fileState.imagefiledata}
            groupdata={fileState.allFilesList}
            previewopen={FilePreviewer} />}
        </div>}
      </div>
    </>
  );
};

